import React from 'react'
import { Col, Row } from 'react-bootstrap'
import asset26 from '../../../assests/img/Asset 26.svg'
import asset28 from '../../../assests/img/Asset 28.svg'
import asset29 from '../../../assests/img/Asset 29.svg'

const Certification = () => {
    return (
        <>
            <div className='certification'>
                <div className='coustom_container'>
                    <h3>Quality, Accreditation & Certifications</h3>
                    <Row>
                        <Col lg={4} md={6} sm={12}>
                            <div className='certification_card'>
                                <img src={asset29} alt='asset29' />
                                <div className='certification_text'>
                                    <h3>100+</h3>
                                    <p>Instruments used for real time QC monitoring</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={6} sm={12}>
                            <div className='certification_card'>
                                <img src={asset28} alt='asset28' />
                                <div className='certification_text'>
                                    <h3>100+</h3>
                                    <p>Instruments used for real time QC monitoring</p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} md={6} sm={12}>
                            <div className='certification_card'>
                                <img src={asset26} alt='asset26' />
                                <div className='certification_text'>
                                    <h3>100+</h3>
                                    <p>Instruments used for real time QC monitoring</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
    )
}

export default Certification